$(window).load(function () {
    'use strict';

    $('.gridRow .twoColumn').each(function () {
        var correctHeight = $(this).parents('.gridColumn').outerHeight();

        if($(window).width() > window.breakpoints.tablet) {
            $(this).find('.js_columnHeight').outerHeight(correctHeight);
        }

    });

    $('.gridRow .reviewsBlock').each(function () {
        var this_parent_height = $(this).parents('.gridColumn').outerHeight(),
            inner_title_height,
            content_height,
            paddingAmount;

        $(this).height(this_parent_height);

        if($(this).parents('.twoColumn').length === 0) {

            inner_title_height = $(this).find('.title').height();
            content_height = $(this).find('ul').outerHeight();

            paddingAmount = content_height + inner_title_height;
            paddingAmount =  (this_parent_height - paddingAmount) / 2 - 1;

            $(this).find('.title').css({
                paddingTop:  paddingAmount,
                paddingBottom:  paddingAmount
            });
        }
    });

    $('.gridColumn .contentArea').each(function () {
        var block_height = $(this).outerHeight();

        if (block_height > 300) {
            $(this).attr('data-height', block_height);

            $(this).addClass('heightLimit').css({'height': 300});

            $(this).after('<a href="" class="viewMore js_gridViewMore">View more</a>');
        }

    });

    $(document).on('click', '.js_gridViewMore', function(e) {
        e.preventDefault();

        var textcontent = $(this).prev(),
            block_height = textcontent.outerHeight();

        if (block_height == 300) {
            $(this).addClass('active');

            textcontent.css({'height': textcontent.find('.verticalAlign').outerHeight()});

            setTimeout(function () {
                textcontent.css({'height': ''});
            }, 300);
        } else {
            $(this).removeClass('active');

            textcontent.css({'height': textcontent.find('.verticalAlign').outerHeight()});
            setTimeout(function () {
                textcontent.css({'height': 300});
            }, 50);
        }
    });
});